import { fetcher } from '@/utils/fetcher';
import { useQuery } from '@tanstack/react-query';
import { RETAIL_API_URL } from 'src/utils/envConfig';
import { PlayerContent, PlayerContentSchema } from 'src/types/ContentPayload';

export const useContentForUnit = (unitId: string | undefined) => {
  return useQuery({
    queryKey: ['content-for-unit', unitId!],
    queryFn: async (): Promise<PlayerContent> => {
      const response = await fetcher(
        `${RETAIL_API_URL}/players/contentPayload?unitId=${unitId}&version=2&shouldReturnScript=true`,
      );

      try {
        const parsed = PlayerContentSchema.passthrough().parse(response);
        return parsed;
      } catch (error) {
        console.error('Schema parsing error:', error);
        throw error;
      }
    },
    enabled: Boolean(unitId),
  });
};
